export default __webpack_public_path__ + "static/media/191.844c462a.jpg";